export default "__VITE_ASSET__DOjrEMpR__"